import { observable, action, computed, runInAction } from "mobx";
import { route } from "preact-router";

class Store {
  @observable cookiebarDismissed = false;
  @observable sticky = false;
  @observable servicesHeaderInfo = false;
  @observable lang = "lv";
  @observable langContent = null;
  @observable activePage = "/";
  @observable modalState = "";
  @observable user = {};
  @observable loggedIn = false;
  @observable loginEmail = "";
  @observable loginPassword = "";
  @observable modalLoading = false;
  @observable loginError = "";
  @observable hideMenu = false;
  @observable stuck = false;
  @observable desiredService;
  @observable desiredAddress;
  @observable foundAddress;
  @observable searchRunning = false;
  @observable haveResults = false;
  @observable redirectTo = "";

  @observable foundServices;
  @observable foundTitle;
  @observable foundFly;

  @observable mobileMenu = false;
  @observable client;
  @observable activeLocationSlider = null;
  @observable locations = [];

  langs = ["lv", "en", "ru"];
  // client = {
  // 	info: {
  // 		name: "SIA «Advanced Learning & Communications»",
  // 		nr: "40006857846",
  // 		adres: "Brīvības gatve 214m-2",
  // 		country: "Latvija",
  // 		city: "Rīga",
  // 		index: "LV-1021",
  // 		bank: "LV50HABALV24536451241",
  // 		swift: "NABALV50",
  // 		person: "Dmitrijs Krasnovskis",
  // 	},
  // 	cart: {
  // 	   orders: [
  // 			 { status: true, price: 100, date: '16.03.2019'},
  // 			 { status: false, price: 99.99, date: '16.03.2019'},
  // 			 { status: false, price: 99.99, date: '16.03.2019'},
  // 			 { status: false, price: 99.99, date: '16.03.2019'}
  // 		 ]
  // 	}
  // }

  constructor() {
    if (typeof window !== "undefined") {
      this.cookiebarDismissed = !!localStorage.cookiebarDismissed;
      // this.desiredAddress = localStorage.desiredAddress;
      if (!localStorage.calcModalDismissed)
        setTimeout(() => this.showModal("calc"), 10000);
    }
  }
  @action.bound dismissCookiebar() {
    if (typeof window !== "undefined")
      localStorage.cookiebarDismissed = this.cookiebarDismissed = true;
  }
  @action.bound setServicesHeaderInfo(val) {
    this.servicesHeaderInfo = val;
  }
  @action.bound setSticky(val) {
    this.sticky = val;
    if (val) this.stuck = true;
  }
  @action.bound setLang(val) {
    if (this.lang == val) return;
    this.lang = val;
    if (typeof document !== "undefined")
      document.getElementsByTagName("html")[0].setAttribute("lang", val);
  }
  @action.bound setActiveLocationSlider(val) {
    this.activeLocationSlider = val;
  }
  @action.bound showModal(state = "") {
    this.modalState = state;
  }
  @action.bound setRedirect(val) {
    this.redirectTo = val;
  }
  @action.bound doLogin() {
    let creds = {
      email: this.loginEmail,
      password: this.loginPassword
    };
    this.loginError = "";
    this.loginPassword = "";
    //fetch()
    this.modalLoading = true;
    setTimeout(() => {
      this.modalLoading = false;
      // this.modalState = '';
      this.loginError = "Nepareizs e-pasts vai parole!";
      // route('/lv/profile');
    }, 1000);
  }
  @action setContent(val) {
    this.langContent = val;
  }
  @action setDesiredService(value) {
    this.desiredService = value;
  }
  @action setDesiredAddress(value) {
    this.desiredAddress = value;
  }

  async getData1(url) {
    let response = await fetch(url);
    return await response.json();
  }

  @action async loadAddressInfo(id) {
    this.haveResults = false;
    this.searchRunning = true;
    route(store.prefix + "/availability?sid=" + id, true);
    let data = await this.getData1(
      "https://api.dev.dolphnet.lv/services.php?id=" + id
    );
    runInAction(() => {
      if (data && data.d && data.d.services) {
        this.foundServices = data.d.services;
        if (data.d.location) {
          if (data.d.location.address) {
            this.desiredAddress = this.foundTitle = data.d.location.address;
          }
          if (data.d.location.geom && data.d.location.geom.coordinates)
            this.foundFly = data.d.location.geom.coordinates;
        }
      }
      this.haveResults = true;
      this.searchRunning = false;
    });
  }

  @action resetAddressInfo() {
    this.foundServices = false;
    this.foundFly = false;
    this.foundTitle = false;
    this.haveResults = false;
    this.searchRunning = false;
    route(store.prefix + "/availability", true);
  }

  @action resetAddressInfoWithoutRoute() {
    this.foundServices = false;
    this.foundFly = false;
    this.foundTitle = false;
    this.haveResults = false;
    this.searchRunning = false;
  }

  @action.bound toggleMenu(hide = false) {
    if (hide) this.mobileMenu = false;
    else this.mobileMenu = !this.mobileMenu;
  }

  @computed get loginFormValid() {
    return this.loginEmail && this.loginPassword;
  }
  @computed get prefix() {
    return "/" + this.lang;
  }
  /**/
  async sendForm(formName = "contact", values) {
    // console.log('Sending form',formName,'values',values);
    try {
      let req = await fetch("https://www.dolphnet.lv/pieteikumi.php", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({ ...values, formName })
      });

      let response = await req.json();
      // console.log('got response',response);
      return response && response.d && response.d.ok;
    } catch (e) {
      return false;
    }
  }

  async fetchBC() {
    // Fetch only once, also don't initiate two requests
    if (this.locationsFetching || (this.locations && this.locations.length))
      return new Promise(resolve => resolve(this.locations));
    this.locationsFetching = true;
    let req = await fetch("https://api.dev.dolphnet.lv/bc.php");
    return (this.locations = (await req.json()).features);
  }

  loadGA() {
    /* GA*/
    setTimeout(() => {
      (function (i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        (i[r] =
          i[r] ||
          function () {
            (i[r].q = i[r].q || []).push(arguments);
          }),
          (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(
        window,
        document,
        "script",
        "https://www.google-analytics.com/analytics.js",
        "ga"
      );
      ga("create", "UA-139699233-1", "auto");
      ga("send", "pageview");
    }, 1000);
    /* END GA */
  }
}

const store = new Store();
export default store;



// WEBPACK FOOTER //
// ./store/index.js